module.exports = __webpack_public_path__ + "img/GP 2 BSB Circlecon Bulgaria.aa6c6619.jpg";